import { DateTime } from "luxon";
import type { AgentActionHistory } from "./models";
import { AgentActionType } from "./models";

export const generateHistoryData = (eligibleNursesCount: number = 20): AgentActionHistory[] => {
	return [
		{
			created_at: DateTime.now().minus({ seconds: 1 }).toISO(),
			action_type: AgentActionType.Message,
			eligible_nurses_count: eligibleNursesCount,
			target_notification_count: 5,
			notification_percentage: 5 / eligibleNursesCount,
			skip_reason: null,
			nurse_actions: [],
			is_dry_run: true,
		},
	];
};

export const generateDemoData = (daysFromNow: number, datePart: "days" | "hours" = "hours", eligibleNursesCount: number = 20): AgentActionHistory[] => {
	return [
		{
			created_at: DateTime.now().plus({ hour: 2 }).toISO(),
			action_type: AgentActionType.Message,
			eligible_nurses_count: eligibleNursesCount,
			target_notification_count: 10,
			notification_percentage: 15 / eligibleNursesCount, // 5 + 10
			skip_reason: null,
			nurse_actions: [],
			is_dry_run: true,
		},
		{
			created_at: DateTime.now().plus({ hour: 3 }).toISO(),
			action_type: AgentActionType.Call,
			eligible_nurses_count: eligibleNursesCount,
			target_notification_count: 1,
			notification_percentage: 16 / eligibleNursesCount, // 5 + 10 + 1
			skip_reason: null,
			nurse_actions: [],
			is_dry_run: true,
		},
		{
			created_at: DateTime.now().plus({ hour: 4 }).toISO(),
			action_type: AgentActionType.PreferredAgency,
			eligible_nurses_count: eligibleNursesCount,
			target_notification_count: null,
			notification_percentage: null,
			skip_reason: null,
			nurse_actions: [],
			is_dry_run: true,
		},
		{
			created_at: DateTime.now().plus({ hour: 4 }).toISO(),
			action_type: AgentActionType.Call,
			eligible_nurses_count: eligibleNursesCount,
			target_notification_count: 1,
			notification_percentage: 17 / eligibleNursesCount,
			skip_reason: null,
			nurse_actions: [],
			is_dry_run: true,
		},
		{
			created_at: DateTime.now().plus({ hour: 6 }).toISO(),
			action_type: AgentActionType.Agency,
			eligible_nurses_count: eligibleNursesCount,
			target_notification_count: null,
			notification_percentage: null,
			skip_reason: null,
			nurse_actions: [],
			is_dry_run: true,
		},
	];
};
